import * as React from 'react';
import { Link } from '@tanstack/react-router';
import { t } from '@reos/i18n';

/** Neznama adresa: ceska hlaska a cesta zpet, navigace aplikace zustava. */
export function AppNotFoundScreen(): React.ReactElement {
  return (
    <div className="mx-auto max-w-xl py-12" data-testid="app-not-found">
      <h1 className="mb-2 text-xl font-bold">{t('webAdmin.appNotFound.title', { locale: 'cs' })}</h1>
      <p className="mb-4 text-sm text-gray-600">{t('webAdmin.appNotFound.detail', { locale: 'cs' })}</p>
      <Link to="/prehled" className="font-semibold underline">
        {t('webAdmin.appNotFound.back', { locale: 'cs' })}
      </Link>
    </div>
  );
}
